import { render, staticRenderFns } from "./CostGlAssignModal.vue?vue&type=template&id=db70235a&scoped=true"
import script from "./CostGlAssignModal.vue?vue&type=script&lang=js"
export * from "./CostGlAssignModal.vue?vue&type=script&lang=js"
import style0 from "./CostGlAssignModal.vue?vue&type=style&index=0&id=db70235a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db70235a",
  null
  
)

export default component.exports